import { MessageService } from 'primeng/api';
import { Message } from 'primeng/api/message';
import { catchError, of } from 'rxjs';

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { User } from '../../../models/user';
import { SettingsService } from '../../../services/settings.service';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { GetIpResponce } from '../../../models/ip_response';
import { SocketService } from 'src/app/services/socket.service';
import { AuthService } from 'src/app/services/auth.service';
import { AuthDomainService } from '../../../domains/auth.service';
import { UserDomainService } from 'src/app/domains/user.service';

@Component({
  selector: 'race-auth',
  templateUrl: './race-auth.component.html',
  styleUrls: ['./race-auth.component.scss'],
})
export class RaceAuthComponent implements OnInit {
  @Input() lang!: string;
  @Input() user: User | null = null;
  @Input() redirectUrl: string = ''; // Опциональный параметр для редиректа

  @Output() login: EventEmitter<User | null> = new EventEmitter();

  phone = '';
  email: string | undefined = undefined;
  loading = false;
  msgs: Message[] = [];
  initFlaq: boolean;
  notRussia: boolean = false;
  reqConfirm = false;
  isEmailVerified = false;
  pass!: string;
  remainderTextInput: string;
  messages: Array<Message> = [];
  phoneNumber: string = '';

  countryCode: string = 'ru';
  showDialogForEnterPhonePincode: boolean = false;
  waitInltInput = true;
  blockUi: any;
textCallNumber: string | null = null;
  callCheckId: string | null = null;
  callCheckTimer: any = null;

  constructor(
    public authService: AuthService,
    private authDomainService: AuthDomainService,
    private userDomainService: UserDomainService,
    private socketService: SocketService,
    public settingService: SettingsService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {
    this.remainderTextInput = 'password';
    this.initFlaq = false;
  }

  setDefault() {
    this.showDialogForEnterPhonePincode = false;
    this.authService.authProcess = false;
    this.pass = '';
    this.stopCallStatusPolling();
    this.textCallNumber = null;
    this.callCheckId = null;
  }

  logout() {
    this.user = null;
    this.setDefault();
    this.login.emit(this.user);
  }

  ngOnInit() {
    this.initFlaq = true;

    // Обработка возврата после авторизации через Госуслуги (ЕСИА)
    // Бэкенд редиректит обратно с параметром ?esia=success или ?esia_error=...
    const urlParams = new URLSearchParams(window.location.search);
    const esiaSuccess = urlParams.get('esia');
    const esiaError = urlParams.get('esia_error');

    if (esiaSuccess === 'success') {
      // Очищаем URL от параметров ЕСИА
      window.history.replaceState({}, document.title, window.location.pathname);
      // Проверяем авторизацию — сессия уже установлена бэкендом
      this.loading = true;
      this.authDomainService
        .checkAuth()
        .toPromise()
        .then((user) => {
          if (user) {
            this.authService.setUser(user);
            this.user = user;
            this.login.emit(this.user);
            if (this.redirectUrl) {
              this.performRedirect(this.user);
            }
          }
        })
        .catch(() => {
          this.messageService.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: 'Не удалось завершить вход через Госуслуги',
          });
        })
        .finally(() => {
          this.loading = false;
          this.cdr.detectChanges();
        });
      return;
    }

    if (esiaError) {
      // Очищаем URL от параметров ЕСИА
      window.history.replaceState({}, document.title, window.location.pathname);
      const errorMessages: { [key: string]: string } = {
        auth_error: 'Ошибка авторизации на Госуслугах',
        no_phone: 'Не удалось получить номер телефона из Госуслуг',
        server_error: 'Ошибка сервера при авторизации через Госуслуги',
        not_configured: 'Вход через Госуслуги временно недоступен. Попробуйте позже.',
      };
      this.messageService.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: errorMessages[esiaError] || 'Ошибка авторизации через Госуслуги',
      });
    }

    // Используем authService.user который уже загружен в конструкторе AuthService
    if (this.authService.user) {
      this.user = this.authService.user;
      this.login.emit(this.user);

      // Если задан redirectUrl и пользователь уже авторизован, выполняем редирект
      if (this.redirectUrl) {
        this.performRedirect(this.user);
      }
    }

  }

  // Авторизация через Госуслуги (ЕСИА) — редирект на бэкенд /api/auth/esia/login
  loginViaEsia() {
    const urlGTM = this.settingService.settings.urlGTM;
    const currentUrl = window.location.href;
    window.location.href = `${urlGTM}/api/auth/esia/login?redirect=${encodeURIComponent(currentUrl)}`;
  }

  // Проверка корректности номера и если он корректный, получение уида пользователя
  // и если он есть, то показываем ввод пароля, если нет, то авторизация по пинкоду/звонку
  checkPhone() {
    this.stopCallStatusPolling();
    const valid = this.authService.input.isValidNumber();
    this.messageService.clear();
    if (valid) {
      const phone = this.authService.input.getNumber();
      const countryData = this.authService.input.getSelectedCountryData();
      if (countryData.iso2 !== 'ru') {
        this.notRussia = true;
      } else {
        this.notRussia = false;
      }
      this.loading = true;
      this.phone = phone;
      this.userDomainService
        .getUserByPhone(`${this.phone}`)
        .toPromise()
        .then((ret) => {
          if (ret) {
            const { cUid, isEmailVerified } = ret;
            this.isEmailVerified = isEmailVerified;
            if (cUid !== '') {
              this.reqConfirm = false;
              this.remainderTextInput = 'password';
            } else {
              this.pass = '';
              this.reqConfirm = true;
              this.remainderTextInput = 'noauth';
              this.setDefault();
            }
          }
        })
        .catch(() => {
          this.pass = '';
          this.reqConfirm = true;
          this.remainderTextInput = 'noauth';
          this.setDefault();
        })
        .finally(() => {
          this.loading = false;
          this.cdr.detectChanges();
        });
    } else {
      this.reqConfirm = false;
      this.phone = '';
    }
  }

  // Обработка изменения номера телефона из нового компонента
  onPhoneNumberChange(phoneNumberData: any) {
    this.phoneNumber = phoneNumberData.value || '';
    this.phone = this.phoneNumber.replace(/\D/g, ''); // Убираем нецифровые символы
    this.checkPhone();
  }

  // Обработка изменения страны
  onCountryChange(country: any) {
    this.countryCode = country.iso2.toLowerCase();
    this.phone = '';
    this.setDefault();
    this.messageService.clear();
    if (this.authService.input) {
      this.authService.input.setNumber(this.phone);
    }
    this.checkPhone();
  }

  // Привязка поля ввода телефона к сервису проверки корректности ввода
  telInputObject(input: any) {
    this.authService.input = input;
    this.checkPhone();
  }

  // При вводе пароля или пинкода чтобы логинился по Enter
  eventHandler(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      if (this.phone && this.pass) {
        this.authUser(!this.reqConfirm && !this.showDialogForEnterPhonePincode);
      }
    }
  }

  // При вводе пинкода чтобы логинился сразу после ввода 4 цифр
  onPinKeyUp() {
    if (this.pass.length === 4) {
      this.authUser();
    }
  }

  // Отправка пароля (если пользователь есть в базе по номеру телефона) или пинкода, если новый
  sendPin() {
    this.textCallNumber = null;
    this.callCheckId = null;
    this.stopCallStatusPolling();
    this.showDialogForEnterPhonePincode = true;
    this.authDomainService
      .sendPin(`${this.phone}`, 'pin');
  }

  // Отправка пароля существующему пользователю
  sendPass() {
    this.messageService.clear();
    this.authDomainService
      .sendPin(this.phone)
      .then(() => {
        this.messageService.add({
          severity: 'info',
          summary: this.settingService.translate[this.settingService.selectedLang]['info'],
          detail: this.settingService.getTranslate('waitSmsPass'),
        });
      })
      .catch((err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.settingService.translate[this.settingService.selectedLang]['error'],
          detail: err && err.message ? err.message : this.settingService.getTranslate('errorCallInit'),
        });
      });
  }

  // Отправка пароля существующему пользователю
  sendPassToEmail() {
    if (this.isEmailVerified && !this.notRussia) {
      this.authDomainService
        .sendPin(this.phone);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.settingService.translate[this.settingService.selectedLang]['error'],
        detail: this.settingService.translate[this.settingService.selectedLang]['needVerifiedEmail'],
      });
      this.reqConfirm = true;
      this.showDialogForEnterPhonePincode = false;
    }
  }

  // Отказ от ввода пинкода
  cancelPincode() {
    this.setDefault();
    this.messageService.clear();
  }

  // Инициализация входа по звонку (sms.ru callcheck).
  // Пользователю показывается номер стороннего оператора, на который нужно позвонить,
  // после звонка sms.ru подтверждает номер (webhook), а клиент периодически
  // опрашивает GET /auth/callcheck_status, пока сервер не авторизует его в сессии.
  showCallCheckInit() {
    this.messageService.clear();
    this.loading = true;
    this.showDialogForEnterPhonePincode = false;
    this.authDomainService
      .initCallCheck(`${this.phone}`)
      .then((ret) => {
        this.callCheckId = ret.check_id;
        const callPhoneRaw = ret.call_phone || '';
        const callPhonePretty = ret.call_phone_pretty || callPhoneRaw;
        // Формируем кликабельную ссылку tel: чтобы при нажатии открывался набор номера
        const callPhoneLink = callPhoneRaw
          ? `<a href="tel:${callPhoneRaw}">${callPhonePretty}</a>`
          : callPhonePretty;
        this.textCallNumber = this.settingService.getTranslate('callCheckInfo', [callPhoneLink, '5']);
        this.startCallStatusPolling();
        this.cdr.detectChanges();
      })
      .catch((err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.settingService.translate[this.settingService.selectedLang]['error'],
          detail: err && err.message ? err.message : this.settingService.getTranslate('errorCallInit'),
        });
      })
      .finally(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  // Запуск периодической проверки статуса звонка (раз в 5 секунд)
  startCallStatusPolling() {
    this.stopCallStatusPolling();
    this.pollCallStatusOnce();
    this.callCheckTimer = setInterval(() => this.pollCallStatusOnce(), 5000);
  }

  // Одиночная проверка статуса звонка через GET /auth/callcheck_status
  pollCallStatusOnce() {
    if (!this.callCheckId) return;
    this.authDomainService
      .callcheckStatus(this.callCheckId)
      .then((ret) => {
        // Если сервер вернул пользователя — номер подтверждён и вход выполнен
        if (ret && ret.cUid) {
          this.stopCallStatusPolling();
          this.messageService.clear();
          this.user = new User(ret, true);
          this.textCallNumber = null;
          this.cdr.detectChanges();
          this.setDefault();
          this.login.emit(this.user);

          // Если задан redirectUrl, выполняем редирект с данными пользователя
          if (this.redirectUrl) {
            this.performRedirect(this.user);
          }
        }
      })
      .catch((err) => {
        // Ошибка проверки (например, заявка истекла) — останавливаем опрос
        this.stopCallStatusPolling();
        this.messageService.add({
          severity: 'error',
          summary: this.settingService.translate[this.settingService.selectedLang]['error'],
          detail: err && err.message ? err.message : this.settingService.getTranslate('errorCallInit'),
        });
      });
  }

  // Остановка опроса статуса звонка
  stopCallStatusPolling() {
    if (this.callCheckTimer) {
      clearInterval(this.callCheckTimer);
      this.callCheckTimer = null;
    }
  }

  // Показать подсказку по звонку
  showCallCheckInfo() {
    this.messageService.add({
      severity: 'info',
      summary: this.settingService.translate[this.settingService.selectedLang]['info'],
      detail: this.settingService.getTranslate('callCheckInfoHint'),
    });
  }

  // Показать подсказку по получению пароля
  showPassInfo() {
    this.messageService.add({ severity: 'info', summary: this.settingService.translate[this.settingService.selectedLang]['info'], detail: this.settingService.getTranslate('passwordInfoInit') });
  }

  // Авторизация по почте
  initEmail() {
    if (!this.email || !this.isValidEmail(this.email)) {
      return;
    }
    this.textCallNumber = null;
    this.callCheckId = null;
    this.stopCallStatusPolling();
    this.authDomainService
      .initEmail(this.email, this.settingService.selectedLang)
      .then((ret) => {
        this.showDialogForEnterPhonePincode = true;
        this.messageService.add({ severity: 'info', summary: this.settingService.translate[this.settingService.selectedLang]['info'], detail: this.settingService.getTranslate('waitEmail') });
      });
  }

  public isValidEmail(email: string): boolean {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // Показать подсказку по получению пинкода на email
  showInitInfo() {
    this.messageService.add({ severity: 'info', summary: this.settingService.translate[this.settingService.selectedLang]['info'], detail: this.settingService.getTranslate('waitEmail') });
  }

  // Авторизовать пользователя
  authUser(password = false) {
    this.textCallNumber = null;
    if (this.reqConfirm && password) return;
    if (!this.pass || this.pass.length < 2) {
      this.messageService.add({ severity: 'error', summary: this.settingService.translate[this.settingService.selectedLang]['info'], detail: this.settingService.getTranslate('wrongPassword') });
    } else {
      this.authService.authProcess = true;
      this.authDomainService
        .auth(`${this.phone}`, this.pass, password, this.socketService.getId())
        .then((res) => {
          this.messageService.clear();
          this.user = new User(res, true);
          this.cdr.detectChanges();
          this.setDefault();
          this.login.emit(this.user);

          // Если задан redirectUrl, выполняем редирект с данными пользователя
          if (this.redirectUrl) {
            this.performRedirect(this.user);
          }
        })
        .finally(() => {
          this.authService.authProcess = false;
        });
    }
  }

  // Выполнение редиректа с данными пользователя
  performRedirect(user: User) {
    if (this.redirectUrl) {
      const userData = JSON.stringify(user);
      const encodedData = encodeURIComponent(userData);
      const separator = this.redirectUrl.includes('?') ? '&' : '?';
      const finalUrl = `${this.redirectUrl}${separator}datauser=${encodedData}`;

      // Редирект в том же окне
      window.location.href = finalUrl;
    }
  }

  // // Авторизация по исходящему звонку НЕ ИСПОЛЬЗУЕТСЯ
  // showCallNumberInit() {
  //   this.authService
  //     .showCallNumber(`${this.phone}`, this.reqConfirm, false)
  //     .toPromise()
  //     .then((text: string | undefined) => {
  //       if (text) {
  //         this.textCallNumber = text;
  //         this.cdr.detectChanges();
  //       }
  //     });
  // }

  // // Авторизация по исходящему звонку  - показать подсказку НЕ ИСПОЛЬЗУЕТСЯ
  // showCallInfo() {
  //   this.alert2Service.addAlert(
  //     this.settingService.translate[this.settingService.selectedLang]['info'],
  //     `${this.settingService.getTranslate('callInfo')}`,
  //     'info'
  //   );
  //   this.message.emit();
  // }
}
